import { render, staticRenderFns } from "./BusinessMessagelist.vue?vue&type=template&id=6998f49e&scoped=true&"
import script from "./BusinessMessagelist.vue?vue&type=script&lang=js&"
export * from "./BusinessMessagelist.vue?vue&type=script&lang=js&"
import style0 from "./BusinessMessagelist.vue?vue&type=style&index=0&id=6998f49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6998f49e",
  null
  
)

export default component.exports